module.exports = new __parcel__URL__("90891_sq.ca91573b.jpg").toString();